const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftTopWindow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 103",
    width: 54.878,
    height: 99.134,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-primary)"
    },
    points: "0.078 8.597 14.184 58.814 29.327 58.068 21.966 6.096"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-primary)"
    },
    points: "15.35 63.313 26.97 100.983 36.712 100.646 30.315 63.788"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-primary)"
    },
    points: "39.935 100.48 35.696 63.935 52.65 64.497 52.048 100.139"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--theme-primary)"
    },
    points: "35.233 57.617 29.908 4.99 54.956 1.849 52.814 56.885"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTopWindow);
export default __webpack_public_path__ + "static/media/LeftTopWindow.e588c205be0bc88e1c4900978d445b99.svg";
export { ForwardRef as ReactComponent };